export default __webpack_public_path__ + "static/1425-77b459638cb1c0f64fd841f6c3a284dd.gif";